import Seo from "@/components/Seo";
import Hero from "@/components/Hero";
import PortfolioGrid from "@/components/PortfolioGrid";
import { PROJECTS } from "@/data/projects";
import { PAGE_META } from "@/lib/seo-constants";
import { breadcrumbSchema } from "@/lib/jsonld";
import { MAILTO_HREF } from "@/lib/constants";

export default function Projects() {
  const meta = PAGE_META.projects;

  return (
    <>
      <Seo
        title={meta.title}
        description={meta.description}
        path={meta.path}
        jsonLd={[
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Projects", path: "/projects" },
          ]),
        ]}
      />

      <Hero
        image="/images/project-01-warehouse-brick.jpg"
        imageAlt="Completed brick veneer facade on an industrial distribution centre"
        eyebrow="Our Work"
        title="Masonry & Siding Projects Across the GTA"
        subtitle="A selection of commercial and industrial masonry, siding, and construction management work delivered by VCO Group."
        ctaLabel={null}
        size="small"
      />

      <section className="py-20">
        <div className="section-container">
          <PortfolioGrid projects={PROJECTS} />
        </div>
      </section>

      <section className="bg-charcoal py-16">
        <div className="section-container text-center">
          <h2 className="font-display text-2xl font-semibold text-offwhite sm:text-3xl">
            Have A Project In Mind?
          </h2>
          <a
            href={MAILTO_HREF}
            className="mt-6 inline-block rounded bg-brick px-8 py-4 font-display text-base uppercase tracking-wide text-offwhite transition-colors hover:bg-brick-light"
          >
            Email Us
          </a>
        </div>
      </section>
    </>
  );
}
